import { composeU } from '@bem-react/core';
import {
    Link as LinkPresenter,
    withThemeBlack,
    withThemeNormal,
    withThemePseudo
} from '@yandex-lego/components/Link/desktop';

const Link = composeU(
    withThemeBlack,
    withThemeNormal,
    withThemePseudo
)(LinkPresenter);

export default Link;
